import React, { useEffect } from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import ListArticles from '../../lists/ListArticles.jsx';
import FormSubject from '../../forms/FormSubject.jsx';
import FormUploadPDF from '../../forms/FormUploadPDF.jsx';

const PageArticles = () => {
  const [res, req] = useHttpStatus();
  const [settingsRes, settingsReq] = useHttpStatus();

  useEffect(() => {
    req({ url: 'api/quiz/subjects/all' });
    settingsReq({
      url: 'api/quiz/setting',
    });
  }, []);

  return (
    <div>
      <Header>Reading Materials</Header>

      <Tabs>
        <Tab eventKey="articles" title="Articles">
          <div className="pt-4">
            <ListArticles />
          </div>
        </Tab>
        <Tab eventKey="subjects" title="Subjects">
          <div className="pt-4">
            <h6><u>Attachments by subjects</u></h6>
            <PageHttp res={res} className="pt-4">
              {(subjects) => (
                <div className="row">
                  {subjects.map((s) => (
                    <div className="col-6 pb-3" key={s.key}>
                      <FormSubject subject={s} />
                    </div>
                  ))}
                </div>
              )}
            </PageHttp>
          </div>
        </Tab>
        <Tab eventKey='upload' title = '上傳主題選需求 PDF'>
                <PageHttp res={settingsRes}>
      {(doc) => (
        <>
          <FormUploadPDF setting={doc} />
        </>
      )}
    </PageHttp>
        </Tab>
      </Tabs>
    </div>
  );
};

export default PageArticles;
